function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["accent", "arrow", "as", "children", "className", "dataTestId", "icon", "iconPosition", "inverse", "type", "variation", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-param-reassign */
import React, { useMemo, forwardRef } from 'react';
import classnames from 'classnames';
import { ArrowLeft, ArrowRight, ChevronLeft, ChevronRight } from "../Icon";
import { useInverse } from "../BackgroundProvider";
import Text from "../Text";
import StyledButton from "./styled";
import { useBrand } from "../BrandProvider";
import { ThemeContext } from 'styled-components';
/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/button)
 **/
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var accent = _ref.accent,
    arrow = _ref.arrow,
    asProp = _ref.as,
    children = _ref.children,
    customClass = _ref.className,
    dataTestId = _ref.dataTestId,
    iconProp = _ref.icon,
    iconPosition = _ref.iconPosition,
    inverseProp = _ref.inverse,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$variation = _ref.variation,
    variation = _ref$variation === void 0 ? 'primary' : _ref$variation,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'content' : _ref$width,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = React.useContext(ThemeContext) || {};
  var _ref2 = useBrand() || {},
    _ref2$testAttributeNa = _ref2.testAttributeName,
    testAttributeName = _ref2$testAttributeNa === void 0 ? 'data-qa-id' : _ref2$testAttributeNa;
  var testAttributes;
  var getTestAttributes = function getTestAttributes(element) {
    var _testAttributes;
    return ((_testAttributes = testAttributes) === null || _testAttributes === void 0 ? void 0 : _testAttributes[element]) || {};
  };
  if (dataTestId) {
    testAttributes = {};
    testAttributes.default = _defineProperty({}, testAttributeName, dataTestId);
  }
  var inverse = inverseProp !== undefined ? inverseProp : useInverse(theme);
  if (arrow) {
    console.warn('The `arrow` prop on `Button` component is deprecated. Please ' + 'use `iconPosition` prop to give the button an icon.');
  }
  var className = classnames('csl-button', customClass, "csl-button--".concat(variation));
  var icon = useMemo(function () {
    if (!iconProp && iconPosition === 'left' || arrow === 'left') {
      if (theme.button_config_icon_type === 'arrow') {
        return /*#__PURE__*/React.createElement(ArrowLeft, {
          color: "inherit",
          iconSize: "md",
          size: "s2",
          trim: true
        });
      }
      return /*#__PURE__*/React.createElement(ChevronLeft, {
        color: "inherit",
        size: "s2",
        trim: true
      });
    }
    if (!iconProp && iconPosition === 'right' || arrow === 'right') {
      if (theme.button_config_icon_type === 'arrow') {
        return /*#__PURE__*/React.createElement(ArrowRight, {
          color: "inherit",
          iconSize: "md",
          size: "s2",
          trim: true
        });
      }
      return /*#__PURE__*/React.createElement(ChevronRight, {
        color: "inherit",
        size: "s2",
        trim: true
      });
    }
    return iconProp;
  }, [arrow, iconProp, iconPosition, theme.button_config_icon_type]);
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    $accent: accent,
    $arrow: arrow,
    $iconPosition: iconPosition,
    $inverse: inverse,
    $variation: variation,
    $width: width,
    as: asProp || (rest.href ? 'a' : 'button')
  }, getTestAttributes('default'), rest, {
    className: className,
    ref: ref,
    type: type
  }), (iconPosition === 'left' || arrow === 'left') && icon, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    size: "s2",
    weight: theme.button_config_font_weight
  }, children), (iconPosition === 'right' || arrow === 'right') && icon);
});
Button.displayName = 'Button';
export default Button;